<template>
  <div class="page flex-col">
    <PageHeader />

    <!-- 顶部通栏 -->
    <ChannelTopBar />

    <!-- 主体内容：1400px -->
    <div class="channel-main">
      <!-- 顶部轮播：和 ChannelTwo 保持一致 -->
         <div v-if="carouselItems.length > 0">
      <ChannelTwoCarousel :items="carouselItems" /></div>

      <!-- 三栏布局 -->
      <div class="channel-columns flex-row">
        <!-- 左侧：热点榜 + 广告图片 -->
        <div class="column-left flex-col">
          <HotList />
          <a
            v-if="leftAd.imageUrl"
            :href="leftAd.turnUrl"
            target="_blank"
            class="left-ad-item"
          >
            <img
              class="left-ad-image"
              referrerpolicy="no-referrer"
              :src="leftAd.imageUrl"
              :alt="leftAd.textTip || '广告'"
            />
            <span v-if="leftAd.isShowTag === 1" class="ad-tag">广告</span>
          </a>
        </div>

        <!-- 中间：新闻列表 -->
        <div class="column-center">
          <ChannelThreeNews   v-if="carouselLoaded"
            :category-id="categoryId" 
            :exclude-news-id-list="excludeNewsIdList"
          />
        </div>

        <!-- 右侧：杂志 + 图片 -->
        <div class="column-right flex-col">
          <IssuePanel />
          <a
            v-if="rightAd.imageUrl"
            :href="rightAd.turnUrl"
            target="_blank"
            class="right-ad-item"
          >
            <img
              class="right-ad-image"
              referrerpolicy="no-referrer"
              :src="rightAd.imageUrl"
              :alt="rightAd.textTip || '广告'"
            />
            <span v-if="rightAd.isShowTag === 1" class="ad-tag">广告</span>
          </a>
        </div>
      </div>
    </div>

    <PageFooter />

    <!-- ================= 回到顶部按钮 ================= -->
    <button 
      v-show="showBackToTop" 
      class="back-to-top" 
      @click="scrollToTop"
      title="回到顶部"
      aria-label="回到顶部"
    >
      <!-- 使用你提供的图片链接 -->
      <img 
        src="https://image.cbrand.com.cn/default/2026/10/2D3A47A40740459C98A490CF835B4529.png" 
        alt="回到顶部" 
        class="back-to-top-icon"
      />
    </button>
    <!-- =============================================== -->

  </div>
</template>

<script>
import PageHeader from '../detail/components/PageHeader.vue'
import PageFooter from '../detail/components/PageFooter.vue'
import HotList from '../detail/components/HotList.vue'
import IssuePanel from '../detail/components/IssuePanel.vue'
import { fetchAdDetails, resolveAdImage, fetchNewsListL2, mapNewsItem } from '../../api'
import ChannelTopBar from './components/ChannelTopBar.vue'
import ChannelTwoCarousel from './components/ChannelTwoCarousel.vue'
import ChannelThreeNews from './components/ChannelThreeNews.vue'

export default {
  name: 'ChannelThree',
  components: {
    PageHeader,
    PageFooter,
    HotList,
    IssuePanel,
    ChannelTopBar,
    ChannelTwoCarousel,
    ChannelThreeNews
  },
  data() {
    return {
      leftAd: {},
      rightAd: {},
      categoryId: null,
      carouselItems: [],
      excludeNewsIdList: [],
      carouselLoaded: false, // 标记轮播数据是否加载完成
      
      // 新增：控制回到顶部按钮显示
      showBackToTop: false 
    }
  },
  // 新增：监听滚动事件
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  // 新增：组件销毁前移除监听，防止内存泄漏
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  created() {
    this.categoryId = this.$route.query.categoryId
    this.loadAds()
    // 使用 nextTick 确保轮播数据和排除列表都已准备好
    this.$nextTick(() => {
      this.loadCarousel()
    })
  },
  methods: {
    // 新增：处理滚动事件
    handleScroll() {
      // 当页面垂直滚动超过 300px 时显示按钮
      this.showBackToTop = window.scrollY > 300
    },
    // 新增：平滑回到顶部
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    async loadCarousel() {
      if (!this.categoryId) return
      try {
        const { list } = await fetchNewsListL2({
          categoryId: this.categoryId,
          isRecommended: 1,
          pageNum: 1,
          pageSize: 5
        })
        this.carouselItems = list.map(mapNewsItem)
        const idList = list.map(item => item.id).filter(Boolean)
        this.excludeNewsIdList = idList
        console.log('[ChannelThree] loadCarousel, excludeNewsIdList:', idList, 'total items:', list.length)
      } catch (e) {
        console.error('轮播数据加载失败', e)
      } finally {
        // 无论成功失败，都放开渲染，防止新闻列表永远不显示
        this.carouselLoaded = true
      }
    },
    async loadAds() {
      const [leftList, rightList] = await Promise.all([
        fetchAdDetails('cate_t3_hot_btm'),
        fetchAdDetails('cate_t3_ezine_btm')
      ])
      const left = (leftList || [])[0] || {}
      const right = (rightList || [])[0] || {}
      this.leftAd = {
        imageUrl: resolveAdImage(left.imageUrl),
        turnUrl: left.turnUrl || '#',
        textTip: left.textTip || '广告',
        isShowTag: left.isShowTag
      }
      this.rightAd = {
        imageUrl: resolveAdImage(right.imageUrl),
        turnUrl: right.turnUrl || '#',
        textTip: right.textTip || '广告',
        isShowTag: right.isShowTag
      }
    }
  }
}
</script>

<style scoped>
.page {
  width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  background: #fff;
}

.channel-main {
  width: 1400px;
  margin: 0 auto;
  padding-top: 24px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* 三栏布局 */
.channel-columns {
  width: 1400px;
  align-items: flex-start;
}

.column-left {
  width: 320px;
  flex-shrink: 0;
  margin-top: -46px;
  gap: 16px;
}

.column-center {
  width: 685px;
  flex-shrink: 0;
  margin-left: 38px;
}

.column-right {
  width: 320px;
  flex-shrink: 0;
  margin-left: 37px;
  gap: 16px;
}

.right-ad-item,
.left-ad-item {
  display: block;
  width: 100%;
  position: relative;
}

.right-ad-image,
.left-ad-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 4px;
}

.ad-tag {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 0 4px 0 4px;
  line-height: 1.5;
}

/* ================= 回到顶部按钮样式 ================= */
.back-to-top {
  position: fixed;    /* 固定定位，不受页面滚动影响 */
  bottom: 50px;       /* 距离屏幕底部 */
  right: 50px;        /* 距离屏幕右侧 */
  width: 54px;
  height: 54px;
  background-color: transparent; /* 背景透明，图片本身带有圆形 */
  border: none;                  /* 移除边框 */
  border-radius: 50%;            /* 圆形点击区域 */
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;                  /* 保证在最上层 */
  padding: 0;
  outline: none;
  transition: all 0.3s ease-in-out;
  /* 添加阴影让按钮更立体 */
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15));
}

/* 按钮内部图片样式 */
.back-to-top-icon {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 保持图片比例 */
  display: block;
}

/* 鼠标悬停效果 */
.back-to-top:hover {
  transform: scale(1.1); /* 放大 */
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.25)); /* 阴影加深 */
}

/* 点击时的按压效果 */
.back-to-top:active {
  transform: scale(0.95); /* 缩小 */
}
</style>